import { Component, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-form-input',
    styleUrls: ['form-input.component.scss'],
    template: `
    <div class="dynamic-field form-group form-input" [formGroup]="group">
      <label>{{ config.label }}</label>
      <input
        type="text"
        class="form-control"
        [attr.placeholder]="config.placeholder"
        [formControlName]="config.name" />
    </div>
  `,
})
export class FormInputComponent {
    config;
    group: FormGroup;
}




// WEBPACK FOOTER //
// ./src/app/_dynamic_form/components/form-input/form-input.component.ts